import React, { useEffect, useState, useMemo } from 'react';
import {
  Modal,
  Box,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import { fetchWithToken } from '../../../api/apiutils';
import Paging from './ActiveUserPaging'; // Убедитесь, что этот компонент существует

const actionLabels = {
  1: "Кнопка применить",
  2: "Кнопка подробнее",
  3: "Анализ ТС",
  4: "Подбор товара",
  5: "Аналогичные лоты",
  6: "Конкуренты",
  7: "Запланированные лоты",
  8: "Про Анализ",
  9: "Анализ",
  10: "Выгрузка Excel (Избранные товары)",
  11: "Выгрузка Excel (Анализ)",
  12: "Выгрузка Excel (Мои лайки)",
  13: "Читабельный ТС",
  14: "Мои заявки",
  15: "Актуальные заявки",
  16: "Мои лайки",
  17: "История подписок на план",
  18: "Подписка на план",
  19: "Маркетплейс",
  20: "Уведомление",
  21: "Лайк",
  22: "Дизлайк",
  23: "Подписка",
  24: "Применить подписку",
  25: "Подборки",
  26: "Список подписки",
  27: "Все документы",
};

const UserActionsModal = ({ open, onClose, userId, actionDateFrom, actionType }) => {
  const [loading, setLoading] = useState(false);
  const [actions, setActions] = useState([]);
  const [error, setError] = useState(null);
  const [totalCount, setTotalCount] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = useMemo(() => {
    return Math.ceil(totalCount / rowsPerPage);
  }, [totalCount]);

  const fetchActions = async () => {
    if (!userId) return;

    setLoading(true);
    setError(null);

    try {
      const url = new URL(`/api/users/${userId}/actions`, window.location.origin);
      url.searchParams.append('page', currentPage);
      url.searchParams.append('pageLimit', rowsPerPage);
      url.searchParams.append('ActionDateFrom', actionDateFrom);
      if (actionType) {
        url.searchParams.append('Action', actionType);
      }

      const response = await fetchWithToken(url.toString());
      if (!response.ok) throw new Error('Ошибка при получении действий');

      const result = await response.json();
      setActions(Array.isArray(result.data) ? result.data : []);
      setTotalCount(result.all || 0);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      setCurrentPage(1);
    }
  }, [open, userId, actionDateFrom, actionType]);

  useEffect(() => {
    if (open) {
      fetchActions();
    }
  }, [open, currentPage]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        backgroundColor: 'white',
        p: 4,
        maxWidth: '80%',
        maxHeight: '80vh',
        overflowY: 'auto',
        mx: 'auto',
        mt: 10,
        borderRadius: 2
      }}>
        <Typography variant="h6" gutterBottom>
          История действий пользователя
        </Typography>

        {loading ? (
          <Box display="flex" justifyContent="center"><CircularProgress /></Box>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : actions.length === 0 ? (
          <Typography>Нет данных</Typography>
        ) : (
          <>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell><strong>Действие</strong></TableCell>
                    <TableCell><strong>Дата</strong></TableCell>
                    <TableCell><strong>Код ответа</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {actions.map((action, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{actionLabels[action.action] || `Неизвестное (${action.action})`}</TableCell>
                      <TableCell>{new Date(action.date).toLocaleString('ru-RU')}</TableCell>
                      <TableCell>{action.responseCode || '—'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {totalPages > 1 && (
              <Box mt={2}>
                <Paging
                  localPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />
              </Box>
            )}
          </>
        )}
      </Box>
    </Modal>
  );
};

export default UserActionsModal;
